"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function bgImage(image, conditional) {
    if (!conditional) {
        return null;
    }
    return {
        backgroundImage: "url(" + image + ")",
    };
}
exports.bgImage = bgImage;
//# sourceMappingURL=bg_image.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/bg_image.js
// module id = IAou
// module chunks = 20 21